module.exports = () => {
  return [
    {
      name: '试玩页名称',
      value: 'name',
    },
    {
      name: '试玩页路径',
      value: 'url',
    },
    {
      name: '试玩页别名',
      value: 'nick_name',
    },
  ];
};
